// @flow

import Cookies, {get as getCookie} from "js-cookie";

function parserLocation(
    str: ?string
): ?{
    state: string,
    postCode: string,
    branchCode: string
} {
    try {
        if (!str) return undefined;
        return JSON.parse(str);
    } catch (e) {
        return undefined;
    }
}

/**
 * The old post code has not encoded completely which gives errors when passing to newer version of spring
 * boot PLP. The purpose of this method is to decode and encode them correctly and store.
 */
export function encodeCorrectlyAndStoreLocationCookie(){
    const value: ?string = getCookie("reece-user-location");
    if(value && value.includes(",")){
        let cookies:Cookies = Cookies.withConverter({
            write: function (value) {
                return encodeURIComponent(value);
            }
        })
        cookies.set("reece-user-location",value,7);
    }
}

export function getLocationPostcode(): ?string {
    const value: ?string = getCookie("reece-user-location");
    const parsedLocation = parserLocation(value);
    return parsedLocation ? parsedLocation.postCode : undefined;
}